import styled from "@emotion/styled";

const StyledRatioContainer = styled.div`
  position: relative;
  width: 100%;
  padding-top: 150%;
`;

const StyledPhotoContainer = styled.div<{
  zoomImageOnHover?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  max-height: 624px;

  img {
    opacity: 1;
    transition: transform 0.3s ease, opacity 350ms ease-in-out;
  }

  &[data-loaded="false"] {
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.tone.marble};
      animation: progress 2s ease infinite;
    }

    img {
      opacity: 0;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints[1]}) {
    max-height: 370px;
  }

  ${({ zoomImageOnHover }) =>
    zoomImageOnHover &&
    `
      overflow: hidden;

      img:hover {
        transform: scale(1.05);
      }
    `}

  @keyframes progress {
    0% {
      opacity: 0.8;
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.8;
    }
  }
`;

export { StyledRatioContainer, StyledPhotoContainer };
